import debounce from 'lodash/debounce'
import { t } from 'ttag'

import * as h2Api from '../../h2Api'

export const LOAD_SCHOOLS = 'ADMIN_USER_LOAD_SCHOOLS'

export const SEARCH = 'ADMIN_USER_SEARCH'

export const LOAD_MORE = 'ADMIN_USER_LOAD_MORE'

export const LOAD_BACKLOG = 'ADMIN_USER_LOAD_BACKLOG'

export const REFRESH_LIST = 'ADMIN_USER_REFRESH_LIST'

export const SEARCH_SUGGESTIONS = 'ADMIN_USER_SEARCH_SUGGESTIONS'

export const CLEAR_SEARCH_SUGGESTIONS = 'ADMIN_CLEAR_USER_SEARCH_SUGGESTIONS'

export const GROUP_SEARCH = 'ADMIN_USER_GROUP_SEARCH'

export const GROUP_LIST = 'ADMIN_USER_GROUP_LIST'

export const DISMISS_GROUP_LIST = 'ADMIN_USER_DISMISS_GROUP_LIST'

export const GROUP_DELETE = 'ADMIN_USER_GROUP_DELETE'

export const GROUP_TOGGLE_EDIT = 'ADMIN_USER_GROUP_TOGGLE_EDIT'

export const GROUP_TITLE_UPDATE = 'ADMIN_USER_GROUP_TITLE_UPDATE'

export const GROUP_TITLE_CHANGE = 'ADMIN_USER_GROUP_TITLE_CHANGE'

export const GROUP_ADD_MEMBER = 'ADMIN_USER_GROUP_ADD_MEMBER'

export const GROUP_REMOVE_MEMBER = 'ADMIN_USER_GROUP_REMOVE_MEMBER'

export const GROUP_ADD_OWNER = 'ADMIN_USER_GROUP_ADD_OWNER'

export const GROUP_REMOVE_OWNER = 'ADMIN_USER_GROUP_REMOVE_OWNER'

export const GET_PROFILE = 'ADMIN_USER_GET_PROFILE'

export const CLEAR_EDIT_PROFILE = 'ADMIN_USER_CLEAR_EDIT_PROFILE'

export const EDIT_PROFILE_VIEW = 'ADMIN_USER_EDIT_PROFILE_VIEW'

export const CLEAR_PROFILE = 'ADMIN_USER_CLEAR_PROFILE'

export const UPDATE_SELECTIONS = 'ADMIN_USER_ADD_SELECTION'

export const ADD_SELECTION = 'ADMIN_USER_ADD_SELECTION'

export const REMOVE_SELECTION = 'ADMIN_USER_REMOVE_SELECTION'

export const CHANGE_CRITERIA = 'ADMIN_USER_CHANGE_CRITERIA'

export const EDIT_PROFILE_REQUEST = 'ADMIN_USER_EDIT_PROFILE_REQUEST'

export const SEARCH_ACCESS_OPTIONS = 'ADMIN_USER_SEARCH_ACCESS_OPTIONS'

export const REPORT_SELECTION = 'ADMIN_USER_REPORT_SELECTION'

export const CLEAR_REPORT_SELECTION = 'ADMIN_USER_REPORT_CLEAR'

export const REPORT_GROUP_PDF_LOAD = 'ADMIN_USER_REPORT_GROUP_PDF_LOAD'

export const REPORT_GROUP_DEFAULT_DATA_LOAD = 'ADMIN_USER_REPORT_GROUP_DEFAULT_DATA_LOAD'

export const RETRIEVE_PROFILE_FOR_EDIT = 'ADMIN_USER_RETRIEVE_PROFILE_FOR_EDIT'

export const ADD_SEARCH_HISTORY = 'ADMIN_USER_ADD_SEARCH_HISTORY'

export const MANAGER_QUOTA = 'ADMIN_USER_MANAGER_QUOTA'

export const CONFIRM_REMOVE_USER = 'ADMIN_USER_CONFIRM_REMOVE'

export const DELETE_USER = 'ADMIN_USER_DELETE'

export const REMOVE_USER_FROM_MANAGEMENT = 'ADMIN_USER_REMOVE_FROM_MANAGEMENT'

export const REMOVE_USER_FROM_SITE = 'ADMIN_USER_REMOVE_FROM_SITE'

export const CLEAR_ADMIN_PASSWORD_RESET = 'ADMIN_USER_CLEAR_ADMIN_PASSWORD_RESET'

export const ADMIN_PASSWORD_RESET_VIEW = 'ADMIN_USER_PASSWORD_RESET_VIEW'

export const ADMIN_PASSWORD_RESET_REQUEST = 'ADMIN_USER_PASSWORD_RESET_REQUEST'

export const UPDATE_FILTER_PARAM = 'ADMIN_USER_UPDATE_FILTER_PARAM'

export const REPLACE_FILTER = 'ADMIN_USER_REPLACE_FILTER'

export const REMOVE_SCHOOL = 'ADMIN_USER_REMOVE_SCHOOL'

export const REMOVE_GRADE = 'ADMIN_USER_REMOVE_GRADE'

export const REMOVE_ROLE = 'ADMIN_USER_REMOVE_ROLE'

export const BEGIN_COMBINE_USERS = 'ADMIN_USER_BEGIN_COMBINE_USERS'

export const COMBINE_USERS = 'ADMIN_USER_COMBINE_USERS'

export const beginCombineUsers = user => dispatch => {
  return dispatch({ type: BEGIN_COMBINE_USERS, user })
}

export const combineUsers = (primaryUserId, secondaryUserId) => dispatch => {
  return dispatch(
    h2Api.post('/user/combine/active', {
      primaryUserId,
      secondaryUserId
    })({ type: COMBINE_USERS })
  )
}

export const confirmRemoveUser = userAndScope => dispatch => {
  return dispatch({ type: CONFIRM_REMOVE_USER, ...userAndScope })
}

export const deleteUser = user => dispatch => {
  return dispatch(h2Api.post('/user/delete', user)({ type: DELETE_USER }))
}

export const removeUserFromManagement = user => dispatch => {
  return dispatch(
    h2Api.post('/user/removeFromManagement', user)({ type: REMOVE_USER_FROM_MANAGEMENT })
  )
}

export const removeUserFromSite = user => dispatch => {
  return dispatch(
    h2Api.post('/user/removeFromSite', user)({ type: REMOVE_USER_FROM_SITE })
  )
}

export const managerQuota = () => dispatch => {
  return dispatch(h2Api.get('/admin/users/quota')({ type: MANAGER_QUOTA }))
}

export const refreshList = () => dispatch => {
  return dispatch(REFRESH_LIST)
}

export const allAccessOptions = () => {
  if (dynamicValues.userProfile?.hasAdmin) {
    return ['Administrator', 'School Administrator', 'Manager', 'Student']
  }

  if (dynamicValues.userProfile?.hasSchoolAdmin) {
    return ['School Administrator', 'Manager', 'Student']
  }

  return []
}

export const searchAccessOptions = text => dispatch => {
  const accessOptions = allAccessOptions()

  if (!text || !text.trim()) {
    return dispatch({ type: SEARCH_ACCESS_OPTIONS, options: accessOptions })
  }

  return dispatch({
    type: SEARCH_ACCESS_OPTIONS,
    options: accessOptions.filter(opt => {
      return opt.toLowerCase().includes(text.toLowerCase())
    })
  })
}

export const loadSchools = () => {
  return h2Api.get('/admin/users/schools')({ type: LOAD_SCHOOLS })
}

const debouncedUserSearch = debounce((dispatch, getState) => {
  //console.log("Performing debounced search");
  return dispatch(
    h2Api.post(
      '/admin/users/search',
      getState().admin.users.list.search.criteria
    )({ type: SEARCH })
  )
}, 500)

export const searchUsers = (immediate = false) => {
  return (dispatch, getState) => {
    //console.log("Doing search, immediate?", immediate);
    if (!immediate) {
      return dispatch(debouncedUserSearch)
    }

    return dispatch(
      h2Api.post(
        '/admin/users/search',
        getState().admin.users.list.search.criteria
      )({ type: SEARCH })
    )
  }
}

export const loadMoreUsers = (startIndex, stopIndex) => {
  return (dispatch, getState) => {
    const loading = getState().admin.users.list.cards.status === 'loading'

    //console.log("Load requested from", startIndex, "to", stopIndex, "Loading status is", getState().admin.users.lists.cards.status);
    if (loading) {
      dispatch({ type: LOAD_BACKLOG })

      return Promise.resolve(null)
    }

    const length = stopIndex - startIndex

    if (length <= 0) {
      return
    }

    const criteria = {
      ...getState().admin.users.list.search.criteria,
      start: startIndex,
      length
    }

    //console.log("Loading", length, "starting at", startIndex, "and ending at", stopIndex);
    return dispatch(
      h2Api.post(
        '/admin/users/search',
        criteria
      )({ type: LOAD_MORE, startIndex, stopIndex })
    ).then(values => {
      /*
       * Intercepts the promise so we can check the backlogged value before it gets reset
       */
      const backlogged = getState().admin.users.list.cards.backlogged

      if (backlogged) {
        //console.log("Values", values);
        const loaded = ((values && values.userList) || []).length
        const existing = getState().admin.users.list.cards.value.length
        const start = loaded + existing
        const end = start + 250

        console.log(
          'Making backlogged load more request starting at',
          start,
          'ending with',
          end
        )
        dispatch(loadMoreUsers(start, end))
      }

      return values
    })
  }
}

export const searchGroups = criteria => {
  return h2Api.post(
    '/admin/users/groups/search',
    criteria
  )({ type: GROUP_SEARCH, criteria })
}

export const listGroups = () => {
  return h2Api.get('/admin/users/groups/list')({ type: GROUP_LIST })
}

export const dismissGroupList = () => dispatch => {
  dispatch(searchUsers())

  return dispatch({ type: DISMISS_GROUP_LIST })
}

export const addGroupMember = assignment => dispatch => {
  return dispatch(
    h2Api.post(
      '/admin/users/groups/addMember',
      assignment
    )({ type: GROUP_ADD_MEMBER, assignment })
  ).then(resp => {
    dispatch(searchUsers(true)).then(() => resp)
  })
}

export const removeGroupMember = removal => dispatch => {
  return dispatch(
    h2Api.post(
      '/admin/users/groups/removeMember',
      removal
    )({ type: GROUP_REMOVE_MEMBER, removal })
  ).then(resp => {
    dispatch(searchUsers(true)).then(() => resp)
  })
}

export const addGroupOwner = assignment => dispatch => {
  return dispatch(
    h2Api.post(
      '/admin/users/groups/addOwner',
      assignment
    )({ type: GROUP_ADD_OWNER, assignment })
  ).then(resp => {
    dispatch(searchUsers(true)).then(() => resp)
  })
}

export const removeGroupOwner = removal => dispatch => {
  return dispatch(
    h2Api.post(
      '/admin/users/groups/removeOwner',
      removal
    )({ type: GROUP_REMOVE_OWNER, removal })
  ).then(resp => {
    dispatch(searchUsers(true)).then(() => resp)
  })
}

export const deleteGroup = removal => dispatch => {
  return dispatch(
    h2Api.post('/admin/users/groups/remove', removal)({ type: GROUP_DELETE, removal })
  ).then(resp => {
    return resp
  })
}

export const toggleGroupForEdit = group => {
  return { type: GROUP_TOGGLE_EDIT, group }
}

export const updateGroupTitle = (field, value) => dispatch => {
  return Promise.resolve(dispatch({ type: GROUP_TITLE_CHANGE, field, value }))
}

export const updateSelectedGroupTitle = () => (dispatch, getState) => {
  const gs = getState().admin.users.groupings.groupSelected

  console.log(gs)

  return dispatch(
    h2Api.put(`/admin/users/groups/${gs.id}`, gs)({ type: GROUP_TITLE_UPDATE })
  )
}

export const adminResetPassword = (userId, form) => (dispatch, getState) => {
  return dispatch(
    h2Api.post(
      `/user/password/${userId}`,
      form
    )({ type: ADMIN_PASSWORD_RESET_REQUEST, userId })
  )
}

export const getProfile = userId => {
  return { type: GET_PROFILE, userId }
}

export const printAdminPdfUrl = r => {
  switch (r) {
    case '1':
      return '/pdfs/admin/report/dashboardReport.pdf'
    case '2':
      return '/pdfs/admin/report/interestProfiler.pdf'
    case '3':
      return '/pdfs/admin/report/workImportanceProfiler.pdf'
    case '4':
      return '/pdfs/admin/report/skillsProfiler.pdf'
    /*
     *case "5":
     *          return '/pdfs/admin/report/usage';
     */
    case '6':
      return '/pdfs/admin/report/budget.pdf'
    case '7':
      return '/pdfs/admin/report/fileTagReport.pdf'
    case '8':
      return '/pdfs/admin/report/utl.pdf'
    case '9':
      return '/pdfs/admin/report/courseScheduleReport.pdf'
    case '10':
      return '/pdfs/admin/report/lessonPlanReport.pdf'
    case '11': return '/pdfs/admin/report/lessonCompletion.pdf'
  }
}

export const exportAdminUrl = (r, format) => {
  switch (r) {
    case '1':
      return `/export/admin/report/dashboardReport.${format}`
    case '2':
      return `/export/admin/report/interestProfiler.${format}`
    case '3':
      return `/export/admin/report/workImportanceProfiler.${format}`
    case '4':
      return `/export/admin/report/skillsProfiler.${format}`
    case '7':
      return `/export/admin/report/fileTagReport.${format}`
    case '8':
      return `/export/admin/report/utl.${format}`
    case '9':
      return `/export/admin/report/courseScheduleReport.${format}`
    case '10':
      return `/export/admin/report/lessonPlanReport.${format}`
    case '11': return `/export/admin/report/lessonCompletion.${format}`
  }
}
export const getProfileAndReport = (userId, reportId) => {
  return { type: GET_PROFILE, userId, reportId }
}

export const setFilterParam = (key, value) => dispatch => {
  console.log(key, value)

  return dispatch({ type: UPDATE_FILTER_PARAM, key, value })
}

export const retrieveProfileForEdit = userId =>
  h2Api.get(`/user/profile/${userId}/forEdit`)({ type: RETRIEVE_PROFILE_FOR_EDIT })

export const openEditModal = userId => {
  return { type: EDIT_PROFILE_VIEW, userId }
}

export const openPasswordModal = userId => {
  return { type: ADMIN_PASSWORD_RESET_VIEW, userId }
}

export const clearGroupReport = () => dispatch => {
  return dispatch({ type: CLEAR_REPORT_SELECTION })
}

export const clearEditProfile = () => dispatch => {
  return dispatch({ type: CLEAR_EDIT_PROFILE })
}

export const clearPasswordForm = () => dispatch => {
  return dispatch({ type: CLEAR_ADMIN_PASSWORD_RESET })
}

export const clearProfile = () => dispatch => {
  return dispatch({ type: CLEAR_PROFILE })
}

const debouncedSearchSuggestions = debounce((query, dispatch) => {
  return dispatch(
    h2Api.post('/admin/users/search/suggest', query)({ type: SEARCH_SUGGESTIONS })
  )
}, 200)

export const searchSuggestions = query => dispatch => {
  if (query.length < 2) {
    dispatch({ type: CLEAR_SEARCH_SUGGESTIONS })
  }

  debouncedSearchSuggestions(query, dispatch)
}

export const addSearchHistory = criteria => dispatch => {
  return dispatch({ type: ADD_SEARCH_HISTORY, historyItem: criteria })
}

export const updateSelections = selections => {
  return dispatch => {
    dispatch({ type: UPDATE_SELECTIONS, selections })

    return dispatch(searchUsers())
  }
}

export const addSelection = selection => {
  return dispatch => {
    dispatch({ type: ADD_SELECTION, selection })

    return dispatch(searchUsers())
  }
}

export const removeSelection = selection => {
  return dispatch => {
    dispatch({ type: REMOVE_SELECTION, selection })

    return dispatch(searchUsers())
  }
}

export const removeSchool = selection => {
  //console.log("SCH", selection)
  return dispatch => {
    dispatch({ type: REMOVE_SCHOOL, selection })

    return dispatch(searchUsers())
  }
}

export const removeGrade = selection => dispatch => {
  // console.log(selection)
  dispatch({ type: REMOVE_GRADE, selection })

  return dispatch(searchUsers())
}

export const removeUserRole = selection => dispatch => {
  // console.log(selection)
  dispatch({ type: REMOVE_ROLE, selection })

  return dispatch(searchUsers())
}

export const lookupReportTitleFromId = reportId => {
  switch (reportId) {
    case '1':
      return t`Dashboard Report`
    case '2':
      return t`Interest Profiler Report`
    case '3':
      return t`Work Importance Profiler Report`
    case '4':
      return t`Skills Profiler Report`
    case '5':
      return t`30 Day Utilization Report`
    case '6':
      return t`Budget Report`
    case '7':
      return t`File Tagging Report`
    case '8':
      return t`Up The Ladder Report`
    case '9':
      return t`Course Plan Report`
    case '10':
      return t`Assignment Status Report`
    case '11': return t`Lesson Completion Overview`
    default:
      return 'Not found'
  }
}

export const lookupReportIdFromName = inp => {
  const itms = {
    dashboardReport: '1',
    interestProfiler: '2',
    workImportanceProfiler: '3',
    skillsProfiler: '4',
    usage: '5',
    budget: '6',
    tags: '7',
    utl: '8',
    courses: '9',
    assignments: '10'
  }

  return itms[inp]
}

export const loadReportData = (reportId, typeId) => (dispatch, getState) => {
  const state = getState().admin.users
  const filters = getState().admin.users.reports.filter
  const url = ((t, r) => {
    if (t === 'GROUP') {
      const group = state.list.search.recentGroups
      const groupId = group ? group[0].id : null

      switch (r) {
        case '1':
          return `/admin/users/groups/${groupId}/report/groupSummary`
      }
    } else {
      switch (r) {
        case '1':
          return '/admin/users/report/dashboardReport'
        case '2':
          return '/admin/users/report/interestProfiler'
        case '3':
          return '/admin/users/report/workImportanceProfiler'
        case '4':
          return '/admin/users/report/skillsProfiler'
        case '5':
          return '/admin/users/report/usage'
        case '6':
          return '/admin/users/report/budget'
        case '7':
          return '/admin/users/report/tags'
        case '8':
          return '/admin/users/report/utl'
        case '9':
          return '/admin/users/report/courses'
        case '10':
          return '/admin/users/report/assignments'
        case '11':
          return '/admin/users/report/lessonCompletion'
      }
    }
  })(typeId, reportId)

  //console.log(url, reportId, typeId);
  console.log(filters)
  dispatch(addSearchHistory(state.list.search.criteria))

  if (url) {
    if (typeId === 'GROUP') {
      return dispatch(h2Api.get(url)({ type: REPORT_GROUP_DEFAULT_DATA_LOAD }))
    }

    return dispatch(
      h2Api.post(url, {
        ...state.list.search.criteria,
        filters
      })({ type: REPORT_GROUP_DEFAULT_DATA_LOAD })
    )
  }
}

export const selectReport = (reportId, typeId) => {
  return dispatch => {
    return dispatch({ type: REPORT_SELECTION, reportId, typeId })
  }
}

export const displayName = usr => {
  const isSSOLikely = usr.userName.startsWith('___')

  //console.log(usr, dynamicValues.preferenceSSOName, isSSOLikely)
  if (isSSOLikely && usr.hasOwnProperty('ssoName')) {
    return usr.ssoName
  }

  return usr.userName
}

export const changeCriteria = (name, value) => {
  return dispatch => {
    dispatch(searchUsers())

    return dispatch({ type: CHANGE_CRITERIA, change: { [name]: value } })
  }
}

export const replaceCriteria = newCriteria => {
  return dispatch => {
    dispatch({ type: CHANGE_CRITERIA, change: newCriteria })
    dispatch(searchUsers())

    return Promise.resolve(true)
  }
}

export const replaceFilter = newFilter => {
  return dispatch => {
    dispatch({ type: REPLACE_FILTER, value: newFilter })

    return Promise.resolve(true)
  }
}
